import React from 'react';
import { Paper } from '@mui/material'
import theme from '../../../theme';
import { ReadBanner } from '../../../interfaces/core/ReadBanner';

function Item(item: { id: number, image: string | undefined; image_url?: string | undefined; })
{
    const baseURL = process.env.REACT_APP_API_URL;
    const src = item.image_url
        ? item.image_url
        : (item.image && (item.image.startsWith('http://') || item.image.startsWith('https://'))
            ? item.image
            : `${baseURL}/${item.image}`);
    return (
        <Paper style={{ width: '100%', height: theme.breakpoints.down('md') ? '530px' : 'auto' }}>
            <img 
                style={{
                    height: '100%',
                    width: '100%',
                    objectFit: 'fill'
                }}
                src={src} 
                alt="Auto parts"/>
        </Paper>
    )
}

export default Item;